import { type TipoComunicazioneDTO } from '@framework/api-client/api/inquiries-compile/schemas/tipoComunicazioneDTO.ts';
import { type TipoComunicazioneFileAllegatoDTO } from '@framework/api-client/api/inquiries-compile/schemas/tipoComunicazioneFileAllegatoDTO.ts';
import { DividerTitleElement } from '@framework/ui/components/text/DividerTitleElement.tsx';
import { message } from 'antd';
import { type RcFile } from 'antd/es/upload';
import { useTranslation } from 'react-i18next';
import { type CreateCommunicationRequest } from '../../../schema/communication/CreateCommunicationRequestSchema.ts';
import { useCommunicationsContext } from '../context/CommunicationsContext.tsx';
import { AttachmentGroupEditor } from './AttachmentGroupEditor.tsx';

interface CommunicationAttachmentFieldsProps {
  communication?: CreateCommunicationRequest | null;
  communicationType: TipoComunicazioneDTO;
}

export const CommunicationAttachmentFields = (
  props: CommunicationAttachmentFieldsProps,
) => {
  const { communication, communicationType } = props;
  const { t } = useTranslation();

  const { uploadAttachment } = useCommunicationsContext();

  const attachmentGroupList =
    communication?.communicationType?.tipoComunicazioneFileAllegati ??
    communicationType.tipoComunicazioneFileAllegati;

  const handleUpload = async (
    file: RcFile,
    attachmentGroup: TipoComunicazioneFileAllegatoDTO,
  ) => {
    if (!communicationType.id) {
      // biome-ignore format: <tbd>
      const errorMessage = t('communication-attachments.error-type', 'Errore: tipo comunicazione non trovato');
      message.error(errorMessage);
      throw new Error(errorMessage);
    }
    if (!attachmentGroup.id) {
      // biome-ignore format: <tbd>
      const errorMessage = t('communication-attachments.error-attachment-group', 'Errore: gruppo allegati non trovato');
      message.error(errorMessage);
      throw new Error(errorMessage);
    }
    return await uploadAttachment?.(
      communicationType.id,
      attachmentGroup.id,
      file,
    );
  };

  if (!attachmentGroupList || attachmentGroupList.length == 0) return null;

  return (
    <>
      <DividerTitleElement
        title={t('communication-attachments.title', 'Allegati')}
      />
      {attachmentGroupList.map(attachmentGroup => (
        <AttachmentGroupEditor
          key={attachmentGroup.id}
          communication={communication}
          attachmentGroup={attachmentGroup}
          onUpload={file => handleUpload(file, attachmentGroup)}
          likeEmail
        />
      ))}
    </>
  );
};
